import { EndPoint, getURL, Request } from '@model/service';
import uri from 'urijs';
import {
  MediaPostBaseRequestPayload,
  MediaPostRequestPayload,
  MediaPostTripTypesResponse
} from '@model/agents/agents-social-posts-models';
import { MediaPostState } from '@state/slices/agent';

interface MediaPostApiRequests {
  getTripTypes: (payload: MediaPostBaseRequestPayload) => Promise<MediaPostTripTypesResponse>;
  getPostList: (payload: any) => Promise<MediaPostState['posts']>;
}

export class MediaPostApi implements MediaPostApiRequests {
  private api: Request = new Request();

  public async getTripTypes({ loginToken }: MediaPostBaseRequestPayload): Promise<MediaPostTripTypesResponse> {
    return await this.api.get(uri(getURL()).path(EndPoint.MEDIA_POST_TRIP_TYPE).search({ loginToken }).href());
  }

  public async getPostList({ loginToken, payload }: MediaPostRequestPayload): Promise<MediaPostState['posts']> {
    const queryParamas = payload.constructor === Number ? `?id=` : `?tripType=`;

    return await this.api.get(
      uri(getURL()).path(EndPoint.MEDIA_POST).search(`${queryParamas}${payload}`).href(),
      loginToken
    );
  }
}
